import axios from 'axios'
import { make } from 'vuex-pathify'

// initial state
const state = {
  onlinestatuses: [],
  fetchInitiated: false
}

// getters
const getters = {
  ...make.getters(state),

  all({ onlinestatuses }) {
    return onlinestatuses
  },

  forId: ({ onlinestatuses }) => (id) => {
    return onlinestatuses.find(onlinestatus => onlinestatus.id === id)
  }
}

// mutations
const mutations = make.mutations(state)

// actions
const actions = {
  async fetch({ commit, dispatch }) {
    commit('SET_FETCH_INITIATED', true)

    return axios.get('/api/internal/onlinestatuses')
      .then(response => {
        commit('SET_ONLINESTATUSES', response.data.onlinestatuses)
      })
      .catch((err) => {
        dispatch('messages/smartAdd', err, {root: true})
      })
  },

  async fetchOnce({ dispatch, state }) {
    if (state.fetchInitiated) return Promise.resolve()

    return dispatch('fetch')
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
